import {
  Routes,
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import {JhiResolvePagingParams} from 'ng-jhipster';
import {UserRouteAccessService} from '@app/core';
import {GiongPopupComponent} from '@entities/giong/giong-dialog/giong-dialog.component';
import {GiongComponent} from '@entities/giong/giong/giong.component';
import {GiongMgmtDeletePopupComponent} from '@entities/giong/giong-delete-dialog/giong-delete-dialog.component';
import {Injectable} from '@angular/core';
import {
  IGiong,
  Giong,
  IGiongDetail,
  GiongDetail,
} from '@entities/giong/giong.model';
import {GiongService} from '@entities/giong/giong.service';
import {map} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';
import {of} from 'rxjs';
import {GiongImportPopupComponent} from '@entities/giong/giong-import/giong-import.component';
import {GiongDetailComponent} from '@entities/giong/giong-detail/giong-detail.component';
import {GiongStoragePopupComponent} from '@entities/giong/giong-storage-dialog/giong-storage-dialog.component';
import {GiongDeleteHistoryPopupComponent} from '@entities/giong/giong-delete-history-dialog/giong-delete-history-dialog.component';
import {SupplyBlockDetailsResolve} from '@entities/vat-tu';

@Injectable({providedIn: 'root'})
export class GiongManagementResolve implements Resolve<IGiongDetail> {
  constructor(private service: GiongService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = route.params['giong'] ? route.params['giong'] : null;
    if (id) {
      return this.service
        .find(id)
        .pipe(map((giong: HttpResponse<IGiongDetail>) => giong.body));
    }
    return of(new GiongDetail());
  }
}

export const giongRoute: Routes = [
  {
    path: 'danh-sach-giong',
    component: GiongComponent,
    resolve: {
      pagingParams: JhiResolvePagingParams,
    },
    data: {
      authorities: ['can_list_giong'],
      pageTitle: 'entities.giong.giong.list',
    },
    canActivate: [UserRouteAccessService],
  },
];

export const GiongPopupRoute: Routes = [
  {
    path: 'them-giong',
    component: GiongPopupComponent,
    data: {
      authorities: ['can_create_giong'],
      pageTitle: 'entities.giong.giong.add',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'import-giong',
    component: GiongImportPopupComponent,
    data: {
      authorities: ['can_create_giong'],
      pageTitle: 'entities.giong.giong.import',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'sua-giong/:giong',
    component: GiongPopupComponent,
    resolve: {
      giong: GiongManagementResolve,
    },
    data: {
      authorities: ['can_update_giong'],
      pageTitle: 'entities.giong.giong.edit',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'xoa-giong/:giong',
    component: GiongMgmtDeletePopupComponent,
    resolve: {
      giong: GiongManagementResolve,
    },
    data: {
      authorities: ['can_delete_giong'],
      pageTitle: 'entities.giong.giong.delete',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'chi-tiet-giong/:giong',
    component: GiongDetailComponent,
    resolve: {
      giong: GiongManagementResolve,
      pagingParams: JhiResolvePagingParams,
    },
    data: {
      authorities: ['can_detail_giong'],
      pageTitle: 'entities.giong.giong.Chi tiết giống_title',
    },
    canActivate: [UserRouteAccessService],
  },
  {
    path: 'cap-nhat-giong-luu-kho/:giong',
    component: GiongStoragePopupComponent,
    resolve: {
      giong: GiongManagementResolve,
      block: SupplyBlockDetailsResolve,
    },
    data: {
      authorities: ['can_create_warehouse_giong'],
      pageTitle: 'entities.giong.giong.storage',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'xoa-lich-su-giong/:giong',
    component: GiongDeleteHistoryPopupComponent,
    data: {
      authorities: ['can_delete_warehouse_giong'],
      pageTitle: 'entities.giong.giong.Xóa lịch sử giống lưu kho_title',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
];
